import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Alert, Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import bg1 from "../assets/img/bg1.jpeg";
import logo from "../assets/img/logo.png"; // ← ajout du logo
import { useAuth } from "../contexts/AuthContext";

export default function Signin2() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await login(email.trim(), password);
      navigate("/dashboard", { replace: true });
    } catch (err) {
      const msg =
        err?.response?.data?.error ||
        "Identifiants invalides. Veuillez réessayer.";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-sign d-block py-0">
      <Row className="g-0">
        <Col md="7" lg="5" xl="4" className="col-wrapper">
          <Card className="card-sign">
           <Card.Header className="text-center">
  <Link to="/" className="header-logo mb-3 d-inline-block text-decoration-none">
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(11, 29, 30, 0.7)",   // ink CERE avec 85% d'opacité
       
        borderRadius: "10px",
      }}
    >
      <img
        src={logo}
        alt="CERE Gabon"
        style={{
          maxWidth: "120px",
          height: "auto",
          display: "block",
        }}
      />
    </div>
  </Link>
  <Card.Title className="mt-3">Connexion</Card.Title>
  <Card.Text>
    Accédez au back-office du Centre Électronique de Ressources Électorales.
  </Card.Text>
</Card.Header>
            <Card.Body>
              {error && (
                <Alert variant="danger" className="py-2 mb-3">
                  {error}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <Form.Label>Adresse email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="admin@cere-gabon.org"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                    required
                    disabled={loading}
                  />
                </div>

                <div className="mb-4">
                  <Form.Label className="d-flex justify-content-between">
                    Mot de passe
                    <div className="d-flex justify-content-end mb-0">
  <Link to="/forgot-password" className="cere-auth-back" style={{ fontSize: "13px" }}>
    Mot de passe oublié ?
  </Link>
</div>
                  </Form.Label>

                  <div style={{ position: "relative" }}>
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Entrez votre mot de passe"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      autoComplete="current-password"
                      required
                      disabled={loading}
                      style={{ paddingRight: "44px" }}
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      tabIndex={-1}
                      aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "10px",
                        transform: "translateY(-50%)",
                        background: "transparent",
                        border: 0,
                        cursor: "pointer",
                        color: "#6c757d",
                        padding: 4,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {showPassword ? (
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                          <line x1="1" y1="1" x2="23" y2="23"></line>
                        </svg>
                      ) : (
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                          <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                      )}
                    </button>
                  </div>
                </div>

                <Button
                  type="submit"
                  className="btn-sign"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Connexion…
                    </>
                  ) : (
                    "Se connecter"
                  )}
                </Button>
              </Form>
            </Card.Body>
            <Card.Footer>
              Pas encore de compte ?{" "}
              <Link to="">Contactez l'administrateur</Link>
            </Card.Footer>
          </Card>
        </Col>

        <Col className="d-none d-lg-block">
          <img src={bg1} className="auth-img" alt="" />
        </Col>
      </Row>
    </div>
  );
}